import React from "react"
import { Input } from "src/components/ui/input"
import { FormItem, FormLabel, FormMessage } from "src/components/ui/form"
import { ColorPalettePopover } from "./ColorPalettePopover"

// Basics tab: name, description, colour.
//   form    = { name, description, color }
//   set     = (field, value) => void
//   errors  = { name?, color? }
export function TeamBasicsTab({ form, set, errors }) {
  return (
    <div className="space-y-5">
      <FormItem>
        <FormLabel>Name</FormLabel>
        <Input
          value={form.name}
          onChange={(e) => set("name", e.target.value)}
          placeholder="e.g. Closing Team"
          maxLength={60}
        />
        {errors.name && <FormMessage>{errors.name}</FormMessage>}
      </FormItem>

      <FormItem>
        <FormLabel>Description <span className="font-normal text-slate-400">(optional)</span></FormLabel>
        <textarea
          value={form.description}
          onChange={(e) => set("description", e.target.value)}
          placeholder="What is this team for?"
          rows={3}
          className="w-full resize-none rounded-md border border-slate-200 bg-white px-3 py-2 text-[14px] text-slate-900 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-slate-900"
        />
      </FormItem>

      <FormItem>
        <FormLabel>Color</FormLabel>
        <div>
          <ColorPalettePopover value={form.color} onChange={(c) => set("color", c)} />
        </div>
        {errors.color && <FormMessage>{errors.color}</FormMessage>}
      </FormItem>
    </div>
  )
}
